import React from 'react';
import classNames from 'classnames';
import { uiLocations } from 'constants/analytics';
import { getMessage } from 'util/locale';
import PropTypes from 'prop-types';

import BaseTrigger from 'triggers/BaseTrigger';

import { trackAction } from 'util/analytics';

const baseString = 'vra-edit-trigger';
const EditTrigger = ({
  className,
  text = getMessage('button-text__edit-rx'),
  scriptId,
  onClickEditTrigger,
  uiLocation = uiLocations.MANAGE_SCRIPT_NAME,
  disabled = false
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    [`${className}`]: !!className
  });

  const _handleClick = () => {
    trackAction(`Clicked on Edit Prescriptions, Rx: ${scriptId}`);
    onClickEditTrigger({ scriptId, uiLocation });
  };

  return (
    <BaseTrigger
      className={classString}
      content={text}
      dataTestId={baseString}
      disabled={disabled}
      handler={_handleClick}
    />
  );
};

EditTrigger.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClickEditTrigger: PropTypes.func.isRequired,
  scriptId: PropTypes.string.isRequired,
  text: PropTypes.string,
  uiLocation: PropTypes.string
};

export default EditTrigger;
